import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './core/guards/auth-guard';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { QrGeneratorComponent } from './modules/evl/components/qr-generator/qr-generator.component';
import { ViewContentBodyComponent } from './modules/cms/components/contentEntry/view-content-body/view-content-body/view-content-body.component';
import { ContactInfoComponent } from './modules/sys/components/contact/contact-info/contact-info.component';
import { ReportViewerComponent } from './modules/reports/components/cashbook-statment-report/report-viewer/report-viewer.component';
import { TransactionStatusReportComponent } from './modules/cbm/components/transaction/transaction-status-report/transaction-status-report.component';
import { PhotoViewerComponent } from './shared/photo-viewer/components/photo-viewer.component';
import { TimesheetReportViewerComponent } from './modules/reports/components/employee-monthly-timesheet-report/timesheet-report-viewer/timesheet-report-viewer.component';
import { environment } from 'src/environments/environment';
import { DashboardPreviewComponent } from './modules/dsh/components/dashboard-preview/dashboard-preview.component';

const defaultRoute = environment?.apiUrl.includes("snapi")
  ? '/dashboard/ticket'
  : '/dashboard/landing';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: defaultRoute,
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.routes').then((m) => m.AppsRoutes),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      }, {
        path: 'sys',
        loadChildren: () =>
          import('./modules/sys/sys.module').then((m) => m.SysModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'ntf',
        loadChildren: () =>
          import('./modules/ntf/ntf.module').then(
            (m) => m.NTFModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'dms',
        loadChildren: () =>
          import('./modules/dms/dms.module').then(
            (m) => m.DmsModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'evl',
        loadChildren: () =>
          import('./modules/evl/evl.module').then(
            (m) => m.EvlModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'user-evaluation/qrGenerator',
        children: [
          {
            path: 'qr',
            component: QrGeneratorComponent,
            data: { title: "Generate QR Code" }
          }
        ],
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'cms',
        loadChildren: () =>
          import('./modules/cms/cms.module').then(
            (m) => m.CmsModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'contact',
        children: [
          {
            path: 'info',
            component: ContactInfoComponent,
            data: { title: "Contact.Info.Info" }
          }
        ],
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'flw',
        loadChildren: () =>
          import('./modules/flw/flw.module').then((m) => m.FlwModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'gam',
        loadChildren: () =>
          import('./modules/gam/gam.module').then((m) => m.GamModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'swf',
        loadChildren: () =>
          import('./modules/swf/swf.module').then((m) => m.SwfModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'hcm',
        loadChildren: () =>
          import('./modules/hcm/hcm.module').then((m) => m.HcmModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'tkt',
        loadChildren: () =>
          import('./modules/tkt/tkt.module').then((m) => m.TktModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'cbm',
        loadChildren: () =>
          import('./modules/cbm/cbm.module').then((m) => m.CbmModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'rpt',
        loadChildren: () =>
          import('./modules/rpt/rpt.module').then((m) => m.RptModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'gam',
        loadChildren: () =>
          import('./modules/gam/gam.module').then((m) => m.GamModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'dsh',
        loadChildren: () =>
          import('./modules/dsh/dsh.module').then((m) => m.DshModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'mon',
        loadChildren: () =>
          import('./modules/mon/mon.module').then((m) => m.MonModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
    ],
  },
  {
    path: 'user-evaluation',
    loadChildren: () =>
      import('./modules/evl/evl.module').then(
        (m) => m.EvlModule
      ),
  },
  {
    path: "content/entry/:lang/:id",
    component: ViewContentBodyComponent,
    data: { title: "Content.ContentEntry.ViewBody" }
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        (m) => m.AuthModule
      ),
  },
  {
    path: 'fin',
    loadChildren: () =>
      import('./modules/fin/fin.module').then(
        (m) => m.FinModule
      ),
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'contact/us',
  //   loadChildren: () =>
  //     import('./modules/sys/sys.module').then(
  //       (m) => m.SysModule
  //     ),
  // },
  {
    path: "unauthorized",
    component: UnauthorizedComponent,
    data: { title: "Unauthorized" }
  },
  {
    path: 'report/viewer',
    component: ReportViewerComponent,
    data: { title: "Report Viewer" }
  },
  {
    path: 'report/timesheet-viewer',
    component: TimesheetReportViewerComponent,
    data: { title: "Report Viewer" }
  },
  {
    path: 'photo/viewer',
    component: PhotoViewerComponent,
    data: { title: "Photo Viewer" }
  },
  {
    path: 'transaction/status/report',
    component: TransactionStatusReportComponent,
    data: { title: "Report Viewer" }
  },
  {
    path: 'download',
    loadChildren: () =>
      import('./modules/download-app-redirect/download-app-redirect.module').then(
        (m) => m.DownloadAppRedirectModule
      ),
  },
  {
    path: "Dashboard/preview",
    component: DashboardPreviewComponent,
    data: { title: "" }
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
